// websocket
export const SOCKET_CLOSE = "SOCKET_CLOSE";
export const SOCKET_CONNECT = "SOCKET_CONNECT";
export const SOCKET_SEND = "SOCKET_SEND";
export const SOCKET_RECEIVED = "SOCKET_RECEIVED";

//
export const UPDATE_RUNTIME = "UPDATE_RUNTIME";

export const SET_ENTITY = "SET_ENTITY";

// 改变组件的大小和位置
export const MOVE_RESIZE_SET = "MOVE_RESIZE_SET";

// Grid组件的用户自定义数据
export const GRID_DEF_SET = "GRID_DEF_SET";

// api 请求相关
export const API_REQ_START = "API_REQ_START";
export const API_REQ_SUCCESS = "API_REQ_SUCCESS";
export const API_REQ_ERROR = "API_REQ_ERROR";

// file upload
export const FILE_UPLOAD_SET = "FILE_UPLOAD_SET";

// profile
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_SETTING = "UPDATE_SETTING";

// site
export const UPDATE_SITE = "UPDATE_SITE";
